document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.querySelector('[data-clemence-mega-trigger]');
  const menu = document.querySelector('.clemence-mega-menu');
  const topBar = document.querySelector('.top-bar');
  const announcementBar = document.querySelector('.announcementBar');
  const headerGroup = document.querySelector('.shopify-section-group-header-group');

  if (!trigger || !menu || !topBar) return;

  let closeTimer;

  function updateMenuPosition() {
    const topBarRect = topBar.getBoundingClientRect();
    const headerGroupIsSticky = headerGroup && headerGroup.classList.contains('sticky-menu');

    const totalHeight = headerGroupIsSticky
      ? topBarRect.bottom
      : topBar.offsetTop + topBar.offsetHeight - 46;

    document.documentElement.style.setProperty(
      '--clemence-mega-menu-top',
      `${totalHeight}px`
    );

    const triggerRect = trigger.getBoundingClientRect();
    const arrowLeft = triggerRect.left + (triggerRect.width / 2) - 8;

    document.documentElement.style.setProperty(
      '--clemence-mega-menu-arrow-left',
      `${arrowLeft}px`
    );
  }

  function openMenu() {
    clearTimeout(closeTimer);
    updateMenuPosition();
    menu.classList.add('is-active');
    trigger.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    closeTimer = setTimeout(function () {
      menu.classList.remove('is-active');
      trigger.setAttribute('aria-expanded', 'false');
    }, 350);
  }

  trigger.addEventListener('mouseenter', openMenu);
  trigger.addEventListener('focus', openMenu);

  trigger.addEventListener('mouseleave', closeMenu);
  menu.addEventListener('mouseenter', function () {
    clearTimeout(closeTimer);
  });
  menu.addEventListener('mouseleave', closeMenu);

  trigger.addEventListener('click', function (event) {
    if (menu.classList.contains('is-active')) return;

    event.preventDefault();
    openMenu();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      menu.classList.remove('is-active');
      trigger.setAttribute('aria-expanded', 'false');
    }
  });

  window.addEventListener('resize', updateMenuPosition);
  window.addEventListener('scroll', updateMenuPosition);

  updateMenuPosition();
});